import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddNotificationComponent } from './add-notification/add-notification.component';
import { EditNotificationComponent } from './edit-notification/edit-notification.component';
import { NotificationListComponent } from './notification-list/notification-list.component';

const routes: Routes = [
  {
    path:'',
    children:[
      {path:'',redirectTo:'notification-list',pathMatch:'full'},
      {
        path:'notification-list' ,component:NotificationListComponent
      },
      {
        path:'add-notification' , component:AddNotificationComponent
      },
      {
        path:'edit-notification/:id', component:EditNotificationComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationRoutingModule { }
